(function () {
  'use strict';

  var observers = new WeakMap();

  function slugify(value) {
    return value
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[’']/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'section';
  }

  function headingId(heading, usedIds) {
    var existingId = heading.id.trim();
    var existingTarget = existingId ? document.getElementById(existingId) : null;

    if (existingId && !usedIds.has(existingId) && (!existingTarget || existingTarget === heading)) {
      usedIds.add(existingId);
      return existingId;
    }

    var base = slugify(heading.textContent.trim());
    var id = base;
    var suffix = 2;

    while (usedIds.has(id) || document.getElementById(id)) {
      id = base + '-' + suffix;
      suffix += 1;
    }

    heading.id = id;
    usedIds.add(id);
    return id;
  }

  function setActive(root, id) {
    root.querySelectorAll('a[data-toc-target]').forEach(function (link) {
      var active = link.getAttribute('data-toc-target') === id;
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  }

  function buildList(list, chapters) {
    var fragment = document.createDocumentFragment();

    chapters.forEach(function (chapter) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + chapter.id;
      link.textContent = chapter.label;
      link.setAttribute('data-toc-target', chapter.id);
      item.appendChild(link);
      fragment.appendChild(item);
    });

    list.replaceChildren(fragment);
  }

  function init(root) {
    if (root.hasAttribute('data-article-toc-ready')) return;

    var article = root.closest('.signals-article');
    if (!article) return;

    var headings = Array.prototype.slice.call(
      article.querySelectorAll('.signals-article__main .signals-article__body h2')
    ).filter(function (heading) {
      return heading.textContent.trim().length > 0;
    });

    if (headings.length < 3) return;

    var usedIds = new Set();
    var chapters = headings.map(function (heading) {
      return {
        heading: heading,
        id: headingId(heading, usedIds),
        label: heading.textContent.trim()
      };
    });

    root.querySelectorAll('[data-article-toc-list]').forEach(function (list) {
      buildList(list, chapters);
    });

    root.hidden = false;
    root.setAttribute('data-article-toc-ready', '');

    var hashId = '';
    if (window.location.hash) {
      try {
        hashId = decodeURIComponent(window.location.hash.slice(1));
      } catch (error) {
        hashId = window.location.hash.slice(1);
      }
    }
    var initialChapter = chapters.find(function (chapter) { return chapter.id === hashId; }) || chapters[0];
    setActive(root, initialChapter.id);

    root.addEventListener('click', function (event) {
      var link = event.target.closest('a[data-toc-target]');
      if (!link) return;
      setActive(root, link.getAttribute('data-toc-target'));
      var disclosure = link.closest('details[open]');
      if (disclosure) disclosure.removeAttribute('open');
    });

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      var visible = entries
        .filter(function (entry) { return entry.isIntersecting; })
        .sort(function (first, second) { return first.boundingClientRect.top - second.boundingClientRect.top; });

      if (visible.length) setActive(root, visible[0].target.id);
    }, { rootMargin: '-18% 0px -72% 0px' });

    chapters.forEach(function (chapter) { observer.observe(chapter.heading); });
    observers.set(root, observer);
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-article-toc]').forEach(init);
  }

  function unload(scope) {
    scope.querySelectorAll('[data-article-toc]').forEach(function (root) {
      var observer = observers.get(root);
      if (observer) observer.disconnect();
      observers.delete(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { unload(event.target); });
})();
